import { randomIdentifierGenerator } from '../common/random-identifier-generator'
import { XDActions } from './actions'
import { IXDMessage, XDMessage } from './message'

export interface IXDRequest<T> extends IXDMessage<T> {
    /**
     * Id of request, used in `IXDResponse.replyTo`.
     */
    id: string
}

export class XDRequest<T> extends XDMessage<T> implements IXDRequest<T> {
    public id: string

    constructor(
        public readonly action: XDActions,
        public data?: T,
        public readonly ts = Date.now(),
        hash?: number) {

        super(action, data, ts, hash)
        this.id = randomIdentifierGenerator()
        this.updateHash(hash)
    }
}
